import { StatusMemberRegisterWaiting } from 'app/api/event/model'
import { BaseTabs } from 'app/components/common/BaseTabs'
import { IActivityEvent } from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { ActionRegisteredByStatusLayout } from './ActionRegisteredByStatus'
import { useActionRegisteredByStatusLayout } from './hook'
import {
  LabelComponent,
  TabKeysEnum,
} from 'app/containers/EventManagement/RegisterActivity/components'
import { useState } from 'react'

export const ApproveMemberLayout = ({ item }: { item: IActivityEvent }) => {
  const [tab, setTab] = useState(TabKeysEnum.OPEN)

  const waitingHook = useActionRegisteredByStatusLayout({
    status: StatusMemberRegisterWaiting.WAITING,
    actionId: item?.id,
  })

  const acceptedHook = useActionRegisteredByStatusLayout({
    status: StatusMemberRegisterWaiting.ACCEPTED,
    actionId: item?.id,
  })

  const rejectedHook = useActionRegisteredByStatusLayout({
    status: StatusMemberRegisterWaiting.REJECTED,
    actionId: item?.id,
  })

  return (
    <BaseTabs
      onChange={ta => setTab(ta as TabKeysEnum)}
      items={[
        {
          key: TabKeysEnum.WAITING,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.WAITING}
              label="Chờ phê duyệt"
              count={waitingHook?.data?.length}
            />
          ),
          children: (
            <ActionRegisteredByStatusLayout
              status={StatusMemberRegisterWaiting.WAITING}
              locations={item?.locations ?? []}
              data={waitingHook.data ?? []}
              isLoading={waitingHook.isLoading}
            />
          ),
        },
        {
          key: TabKeysEnum.ACCEPTED,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.ACCEPTED}
              label="Đã phê duyệt"
              count={acceptedHook?.data?.length}
            />
          ),
          children: (
            <ActionRegisteredByStatusLayout
              status={StatusMemberRegisterWaiting.ACCEPTED}
              data={acceptedHook.data ?? []}
              isLoading={acceptedHook.isLoading}
            />
          ),
        },
        {
          key: TabKeysEnum.REJECTED,
          label: (
            <LabelComponent
              tabActive={tab}
              tabKey={TabKeysEnum.REJECTED}
              label="Đã từ chối"
              count={rejectedHook?.data?.length}
            />
          ),
          children: (
            <ActionRegisteredByStatusLayout
              status={StatusMemberRegisterWaiting.REJECTED}
              data={rejectedHook.data ?? []}
              isLoading={rejectedHook.isLoading}
            />
          ),
        },
      ]}
    />
  )
}
